<template>
  <div class="view-mode-subsection">
    <Component
      :is="choiceView.is"
      v-if="choiceView"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TemplateProviders from '@/components/Lobby/ViewsProvider/TemplateProviders'
import TemplateGames from '@/components/Lobby/ViewsGame/TemplateGames'
import TemplateCollection from '@/components/Lobby/ViewsCollection/TemplateCollection'
import { LIST_TYPE } from '@/components/Lobby/enum.js'

export default {
  name: 'ViewModeSubsection',
  components: {
    TemplateProviders,
    TemplateGames,
    TemplateCollection,
  },
  computed: {
    ...mapGetters('lobby', [
      'get_sectionList',
      'get_currentSection',
    ]),
    currentSection() {
      return this.get_currentSection(this.$route)
    },
    listType() {
      return this.currentSection?.listType
    },
    choiceView() {
      if (!this.currentSection) return null
      let is = null

      if (this.listType === LIST_TYPE.COLLECTION.NAME) {
        is = 'TemplateCollection'
      }
      else if (this.listType === LIST_TYPE.PROVIDER.NAME) {
        is = 'TemplateProviders'
      }
      else if (this.listType === LIST_TYPE.GAME.NAME) {
        is = 'TemplateGames'
      }
      return {
        is,
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
